/*
 *
 * ChannelsPage constants
 *
 */

export const SET_CLIENT_FILTER      = 'src/ChannelsPage/SET_CLIENT_FILTER';
export const SET_STATUS_FILTER      = 'src/ChannelsPage/SET_STATUS_FILTER';
export const CHANGE_TAB             = 'src/ChannelsPage/CHANGE_TAB';
export const FETCH_CHANNELS_REQUEST = 'src/ChannelsPage/FETCH_CHANNELS_REQUEST';
export const FETCH_CHANNELS_SUCCESS = 'src/ChannelsPage/FETCH_CHANNELS_SUCCESS';
export const FETCH_CHANNEL_DETAIL_REQUEST = 'src/ChannelsPage/FETCH_CHANNEL_DETAIL_REQUEST';
export const FETCH_UPDATED_CHANNEL_DETAIL_REQUEST = 'src/ChannelsPage/FETCH_UPDATED_CHANNEL_DETAIL_REQUEST';
export const FETCH_CHANNEL_DETAIL_SUCCESS = 'src/ChannelsPage/FETCH_CHANNEL_DETAIL_SUCCESS';
export const FETCH_SLUG_VALIDATE_REQUEST = 'src/ChannelsPage/FETCH_SLUG_VALIDATE_REQUEST';
export const FETCH_SLUG_VALIDATE_SUCCESS = 'src/ChannelsPage/FETCH_SLUG_VALIDATE_SUCCESS';
export const FETCH_SLUG_VALIDATE_FAILURE = 'src/ChannelsPage/FETCH_SLUG_VALIDATE_FAILURE';
export const FETCH_CHANNELS_FAILURE = 'src/ChannelsPage/FETCH_CHANNELS_FAILURE';
export const POST_CHANNEL_REQUEST   = 'src/ChannelsPage/POST_CHANNEL_REQUEST';
export const PATCH_CHANNEL_REQUEST  = 'src/ChannelsPage/PATCH_CHANNEL_REQUEST';
export const PATCH_CHANNEL_SUCCESS  = 'src/ChannelsPage/PATCH_CHANNEL_SUCCESS';
export const PUT_CHANNEL_SUCCESS    = 'src/ChannelsPage/PUT_CHANNEL_SUCCESS';
export const PUT_CHANNEL_FAILURE    = 'src/ChannelsPage/PUT_CHANNEL_FAILURE';
export const FETCH_CLIENTS_REQUEST  = 'src/ChannelsPage/FETCH_CLIENTS_REQUEST';
export const FETCH_CLIENTS_SUCCESS  = 'src/ChannelsPage/FETCH_CLIENTS_SUCCESS';
export const FETCH_CLIENTS_FAILURE  = 'src/ChannelsPage/FETCH_CLIENTS_FAILURE';
export const FETCH_THEMES_REQUEST   = 'src/ChannelsPage/FETCH_THEMES_REQUEST';
export const FETCH_THEMES_SUCCESS   = 'src/ChannelsPage/FETCH_THEMES_SUCCESS';
export const FETCH_THEMES_FAILURE   = 'src/ChannelsPage/FETCH_THEMES_FAILURE';
export const FETCH_MODES_REQUEST    = 'src/ChannelsPage/FETCH_MODES_REQUEST';
export const FETCH_MODES_SUCCESS    = 'src/ChannelsPage/FETCH_MODES_SUCCESS';
export const FETCH_MODES_FAILURE    = 'src/ChannelsPage/FETCH_MODES_FAILURE';
export const DELETE_CHANNEL_REQUEST = 'src/ChannelsPage/DELETE_CHANNEL_REQUEST';
export const DELETE_CHANNEL_SUCCESS = 'src/ChannelsPage/DELETE_CHANNEL_SUCCESS';
export const DELETE_CHANNEL_FAILURE = 'src/ChannelsPage/DELETE_CHANNEL_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/constants.js